<template>
  <div class="ui-textarea">
    <label v-if="label" class="ui-label" :for="name">
      {{ label }}
      <span v-if="required" class="ui-required">*</span>
    </label>
    <textarea class="ui-input-field" :value="modelValue" @input="updateValue" :name="name" />
    <div class="ui-hint">
      <slot name="hint"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "UiTextarea",
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },

    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value); // Emit update:modelValue in plaats van input
    },
  },
};
</script>
